// Patch CanvasRenderingContext2D.prototype.drawImage to handle detached ImageBitmap drawing gracefully.
// This prevents application crashes when Konva/Canvas attempts to render an ImageBitmap that has been
// closed/released for GPU memory management.
(function () {
  const originalDrawImage = CanvasRenderingContext2D.prototype.drawImage;
  CanvasRenderingContext2D.prototype.drawImage = function (image) {
    try {
      return originalDrawImage.apply(this, arguments);
    } catch (err) {
      const isDetachedError =
        err instanceof DOMException &&
        (err.name === 'InvalidStateError' || err.code === 11) &&
        err.message &&
        err.message.includes('detached');

      if (isDetachedError) {
        // Silently ignore detached image source errors to prevent app crash.
        // The image is no longer valid, so drawing nothing is the correct behavior.
        return;
      }
      throw err;
    }
  };
})();

import React from 'react';
import ReactDOM from 'react-dom/client';
import { HelmetProvider } from 'react-helmet-async';

import './index.css';
import './i18n'; // Initialize i18next
import * as serviceWorker from './serviceWorker';

import App from './components/App';
import Firebase, { FirebaseContext } from './components/Firebase';

const rootElement = document.getElementById('root');
ReactDOM.createRoot(rootElement).render(
  <FirebaseContext.Provider value={new Firebase()}>
    <HelmetProvider>
      <App />
    </HelmetProvider>
  </FirebaseContext.Provider>
);

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: http://bit.ly/CRA-PWA
serviceWorker.unregister();
